module.exports = __webpack_public_path__ + "img/honor5.ec896556.png";